import { useEffect, useRef, useState } from 'react';

// Intentionally not a deployable contract address. Replace when the token is live.
export const TOKEN_CA_PLACEHOLDER = 'ranordie-ca-placeholder';

export function AppFooter() {
  const [status, setStatus] = useState('');
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  async function copyAddress() {
    clearTimeout(timer.current);
    try {
      await navigator.clipboard.writeText(TOKEN_CA_PLACEHOLDER);
      setStatus('Copied');
    } catch {
      setStatus('Copy failed');
    }
    timer.current = setTimeout(() => setStatus(''), 2500);
  }
  return (
    <footer className="app-footer" aria-label="Project resources">
      <div className="app-footer-token">
        <span className="app-footer-name">ranordie</span>
        <button
          className="app-footer-ca"
          onClick={copyAddress}
          aria-label="Copy placeholder contract address"
          title={'Placeholder only: ' + TOKEN_CA_PLACEHOLDER}
        >
          <span>CA:</span>{' '}
          <span className="app-footer-address">{TOKEN_CA_PLACEHOLDER}</span>
          <span className="app-footer-placeholder">placeholder</span>
        </button>
        <span className="app-footer-status" role="status">
          {status}
        </span>
      </div>
      <div className="app-footer-resources" aria-label="Coming soon">
        {['X', 'Docs', 'Help'].map((name) => (
          <button
            key={name}
            disabled
            aria-label={name + ' — coming soon'}
            title="Coming soon"
          >
            {name}
          </button>
        ))}
      </div>
    </footer>
  );
}
